import React from "react";
import { SocialMedia } from "./styles";
import SocialLink from "../../components/SocialLink";
import { useState } from "react";
import { useEffect } from "react";
import { getSocials } from "../../client";
import imageUrlBuilder from "@sanity/image-url";
import { client } from "./../../client";

const builder = imageUrlBuilder(client);

function urlFor(source) {
  return builder.image(source);
}

const Socials = () => {
  const [socialLinks, setSocialLinks] = useState();

  const callGetSocialLinks = async () => {
    const res = await getSocials();
    setSocialLinks(res);
  };

  useEffect(() => {
    callGetSocialLinks();
  }, []);


  return (
    <SocialMedia>
      {socialLinks?.length > 0 &&
        socialLinks?.map((social) => (
          <SocialLink
            rounded={true}
            link={social?.social_link}
            imgSrc={urlFor(social?.social_image)}
          />
        ))}
    </SocialMedia>
  );
};

export default Socials;
